module.exports = __webpack_public_path__ + "static/img/bg_play1.a2e6828d.png";